export enum PLAYER_CONTROLS {
  PLAY = 'play',
  PLAY_PAUSE = 'play_or_pause',
  PAUSE = 'pause',
  MUTE = 'mute',
  FULLSCREEN = 'fullscreen',
  TRIGGER_FULLSCREEN = 'fullscreen_trigger',
  FORWARD_10 = 'forward',
  BACK_10 = 'back',
  VOLUME_UP = 'volume_up',
  VOLUME_DOWN = 'volume_down'
}

export enum VIDEO_SETTINGS {
  VIDEO_QUALITY = 'Video quality',
  VIDEO_AUDIO = 'Audio',
  VIDEO_SPEED = 'Video speed',
  SUBTITLES = 'Subtitles'
}

export enum VIDEO_QUALITY {
  AUTO = 'auto', // web auto
  HIGH = 'high', // web full HD
  MEDIUM = 'medium', // web HD
  LOW = 'low' // web SD
}

export enum VIDEO_SPEED {
  S_075x = '0.75',
  NORMAL = '01',
  F_125x = '1.25',
  F_150x = '1.5',
  F_175x = '1.75',
  F_200x = '02'
}

export enum VIDEO_SUBTITLES {
  OFF = 'off'
}

export enum VIDEO_AUDIO {
  ENGLISH = 'English'
}

export type VIDEO_SETTING_TYPE = {
  title: string;
};
